import React, { useEffect, useState } from "react";
import { Table, Tooltip, Col, Form, Input, Tabs, Row } from "antd";
import HeadingBack from "../component/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";
import { allapiAction } from "../../Redux/common/action";
import ImageUploading from "react-images-uploading";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import { toast } from "react-toastify";
import { URL } from "../../Redux/common/url";
import Select from "react-select";
import TabPane from "antd/lib/tabs/TabPane";

import { AsyncPaginate } from "react-select-async-paginate";
function AddProperty() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const users_list = useSelector((state) =>
    state?.allapi?.get_sub_category ? state?.allapi?.get_sub_category : {}
  );
  const get_main_all_category = useSelector((state) =>
    state?.allapi?.get_main_all_category
      ? state?.allapi?.get_main_all_category
      : []
  );

  console.log(users_list);

  const listdata = users_list?.docs ? users_list?.docs : [];

  const [subList, setsubList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const dropList = get_main_all_category?.map((data, i) => {
      data.value = data?._id;
      data.label = data?.name;

      return data;
    });

    setsubList(dropList);
  }, [get_main_all_category]);

  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const [showDelelt, setShowDelete] = useState(false);

  const handleCloseDelete = () => setShowDelete(false);
  const [cateID, setcateID] = useState("");

  const hendleDelete = (e) => {
    console.log(e);
    // deleteProduct
    setShowDelete(false);
    dispatch(allapiAction.deletesubCategory({ productId: e, pageNo: page }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [addModalOpen1, setAddModalOpen1] = useState(false);
  const [addModalOpen2, setAddModalOpen2] = useState(false);
  const [addModalOpen3, setAddModalOpen3] = useState(false);

  const hendleModalShow = (e) => {
    // setShowDelete(true)
    setcateID(e);
    setIsModalOpen(true);
  };

  const [cateDetail, setcateDetail] = useState({});
  const [cateDetail1, setcateDetail1] = useState({});
  const [cateDetail3, setcateDetail3] = useState({});

  console.log(cateDetail);

  const [images, setImages] = useState([]);
  const maxNumber = 1;

  console.log(images);

  const [Imagesfe, setImagesfe] = useState("");

  const onChangefe = (imageList, addUpdateIndex) => {
    // data for submit
    // console.log(imageList, addUpdateIndex)
    setImagesfe(imageList);
  };

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  const [selectedOptionUpdate, setSelectedOptionUpdate] = useState(null);

  const hendleTochangeCategory = (e) => {
    const { name, value } = e.target;
    setcateDetail({ ...cateDetail, [name]: value });
  };
  const hendleTochangeCategory3 = (e) => {
    const { name, value } = e.target;
    setcateDetail3({ ...cateDetail3, [name]: value });
  };

  const showModal = (e) => {
    console.log(e);
    setcateDetail(e);
    const selectCate = subList.find((edata) => edata?._id == e?.parentId?._id);

    setSelectedOptionUpdate(selectCate);
    setImagesfe([{ data_url: URL.API_BASE_URL + e.image }]);
    setIsModalOpen(true);
  };
  const handleOk = () => {
    const data = new FormData();
    data.append("name", cateDetail?.name);
    // data.append('description', categoryUpPage)
    data.append("meta_title", cateDetail?.meta_title);
    data.append("meta_description", cateDetail?.meta_description);
    data.append("cate_id", cateDetail?._id);
    data.append("parentId", selectedOptionUpdate?._id);
    data.append("admin_commisstion", cateDetail?.admin_commisstion);
    data.append("pageNo", page);
    if (Imagesfe[0]?.file) {
      // roledata?.role_name
      data.append("image", Imagesfe[0]?.file);
    }
    dispatch(allapiAction.updateperentsubCate(data));
    // dispatch(
    //   allapiAction.updateperentsubCate({
    //     name: cateDetail?.name,
    //     // description: categoryUpPage,
    //     meta_title: cateDetail?.meta_title,
    //     meta_description: cateDetail?.meta_description,
    //     admin_commisstion: cateDetail?.admin_commisstion,
    //     parentId: selectedOptionUpdate?._id,
    //     pageNo: page,
    //     cate_id: cateDetail?._id,
    //   })
    // );
    // dispatch(adminAction.getRoleList('dhsg'))
    setIsModalOpen(false);
    return () => {};
  };

  const handleOkAdd3 = async () => {
    if (!cateDetail3?.name) {
      toast.error("please enter name");
    } else if (!cateDetail3?.loaction) {
      toast.error("please enter loaction");
    } else {
      const data = new FormData();
      data.append("page", 1);
      data.append("name", cateDetail3?.name);
      // data.append('description', aboutPage)
      // data.append("meta_title", cateDetail3?.meta_title);
      // data.append("meta_description", cateDetail3?.meta_description);
      data.append("_id", cateDetail3?._id);
      data.append("loaction", cateDetail3?.loaction);
      data.append("khasranumber", cateDetail3?.khasranumber);
      data.append("sanyojakName", cateDetail3?.sanyojakName);
      data.append("vyavsthapakName", cateDetail3?.vyavsthapakName);
      data.append("kashtkarName", cateDetail3?.kashtkarName);
      data.append("areaBigha", cateDetail3?.areaBigha);
      data.append("schemerate", cateDetail3?.schemerate);
      data.append("developmentCharges", cateDetail3?.developmentCharges);
      data.append("shopRate", cateDetail3?.shopRate);
      data.append("totalPlotArea", cateDetail3?.totalPlotArea);
      data.append("totalRoadArea", cateDetail3?.totalRoadArea);
      // data.append("RegDate", startDate.toISOString().split("T")[0]);
      // data.append('categoryName', 'test cate')
      data.append("parentId", "11");
      data.append("sellerId", "20");
      // data.append("image", images[0]?.file);

      await dispatch(allapiAction.updateScheme(data));
      getDate();
      setcateDetailAdd({
        name: "",
        loaction: "",
        khasranumber: "",
        sanyojakName: "",
        vyavsthapakName: "",
        kashtkarName: "",
        areaBigha: "",
      });
      // dispatch(adminAction.getRoleList('dhsg'))
      setAddModalOpen3(false);
      return () => {};
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [cateDetailAdd, setcateDetailAdd] = useState({});
  console.log(cateDetailAdd);

  const hendleTochangeCategoryAdd = (e) => {
    const { name, value } = e.target;
    console.log(name);

    if (name == "lengths") {
      const area = (cateDetailAdd?.widths * value) / 9;
      console.log(area);

      setcateDetailAdd((prevState) => ({
        ...prevState,
        area: area,
        [name]: value,
      }));
      // setcateDetailAdd({ ...cateDetailAdd, ["area"]: area });
    } else if (name == "widths") {
      const area = (cateDetailAdd?.lengths * value) / 9;
      setcateDetailAdd((prevState) => ({
        ...prevState,
        area: area,
        [name]: value,
      }));
      // setcateDetailAdd({ ...cateDetailAdd, ["area"]: area });
    } else {
      setcateDetailAdd({ ...cateDetailAdd, [name]: value });
    }
  };

  const showModalAdd = (e) => {
    console.log(e);
    setcateDetail(e);
    setAddModalOpen(true);
  };
  const showModalAdd1 = (e) => {
    console.log(e);
    setcateDetail1(e);
    setAddModalOpen1(true);
  };
  const showModalAdd2 = (e) => {
    console.log(e);
    setcateDetail1(e);
    setAddModalOpen2(true);
  };
  const showModalAdd3 = (e) => {
    console.log(e);
    setcateDetail3(e);
    setAddModalOpen3(true);
  };
  const [userselete, setuserselete] = useState(null);
  const [aboutPage, setaboutPage] = useState("");
  const handleOkAdd = async () => {
    if (!cateDetailAdd?.type) {
      toast.error("please enter type");
    } else if (!userselete) {
      toast.error("please select scheme");
    } else if (!cateDetailAdd?.number) {
      toast.error("please enter number");
    } else if (!cateDetailAdd?.area) {
      toast.error("please enter area");
    } else {
      const data = new FormData();
      // data.append("page", 1);
      // data.append("name", cateDetailAdd?.name);
      // // data.append('description', aboutPage)
      // data.append("meta_title", cateDetailAdd?.meta_title);
      // data.append("meta_description", cateDetailAdd?.meta_description);
      // data.append("categoryName", "test cate");
      // data.append("parentId", selectedOption?._id);
      // data.append("sellerId", "20");
      // data.append("image", images[0]?.file);
      if (cateDetailAdd?.lengths) {
        cateDetailAdd.lengthWidth =
          cateDetailAdd?.lengths + "x" + cateDetailAdd?.widths;
      }

      cateDetailAdd.schemeId = userselete?._id;
      const response = await dispatch(allapiAction.createPlot(cateDetailAdd));

      if (response?.success) {
        getDate();
        setcateDetailAdd({
          type: "",
          number: "",
          area: "",
          lengths: "",
          widths: "",
        });
        // dispatch(adminAction.getRoleList('dhsg'))
        setAddModalOpen(false);

        navigate("/property");
      }
      // dispatch(
      //   allapiAction.subcreateCategory({
      //     name: cateDetailAdd?.name,

      //     meta_title: cateDetailAdd?.meta_title,
      //     meta_description: cateDetailAdd?.meta_description,
      //     admin_commisstion: cateDetailAdd?.admin_commisstion,
      //     parentId: selectedOption?._id,
      //   })
      // );

      return () => {};
    }
  };

  const handleCancelAdd = () => {
    setAddModalOpen(false);
  };
  const handleCancelAdd1 = () => {
    setAddModalOpen1(false);
  };

  const handleCancelAdd2 = () => {
    setAddModalOpen2(false);
  };
  const handleCancelAdd3 = () => {
    setAddModalOpen3(false);
  };

  const { confirm } = Modal;

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const hendleToStatus = (id, e) => {
    // statusCategory

    dispatch(allapiAction.statusSubCategory({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //       <div style={{width:"100px"}}>
    //         <img  style={{width:"100%"}} src={URL?.API_BASE_URL +item?.image} alt="" />
    //       </div>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "100px" }}>
              <img
                style={{ width: "100%" }}
                src={URL?.API_BASE_URL + item?.image}
                alt=""
              />
            </div>
          </>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      className: "table_action_col",
    },
    {
      title: "admin commisstion",
      dataIndex: "admin_commisstion",
      key: "admin_commisstion",
      className: "table_action_col",
    },

    {
      title: "Perent Category",
      dataIndex: "parentId",
      key: "parentId",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.parentId?.name}
            </span>
          </>
        );
      },
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title={item?.status}>
              <button
                className={
                  item?.is_status == "Active"
                    ? "success-button ml-3"
                    : "delete-button ml-3"
                }
                onClick={() =>
                  hendleToStatus(
                    item?._id,
                    item?.is_status == "Active" ? "Inactive" : "Active"
                  )
                }
              >
                {item?.is_status}
              </button>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showModal(item);
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            {/* <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                                hendleModalShow(item?.id)
                              }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?._id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    // dispatch(allapiAction.getsubCategoryList(1));
    // dispatch(allapiAction.getcateAllList({}));
    // getDate();
    return () => {};
  }, []);

  const [details, setdetails] = useState({});

  console.log(details);

  const getDate = async () => {
    const response = await dispatch(allapiAction.getSchemeDetails(id));

    if (response?.success) {
      setdetails(response?.data);
    }
  };

  // const [page, setPage] = useState(1);
  const [search, setsearch] = useState("");
  const handleChange = (e) => {
    console.log(e);
    setsearch(e);
    setPage(1);
    if (e) {
      dispatch(allapiAction.allcategorySearch({ page: 1, search: e }));
      return () => {};
    } else {
      dispatch(allapiAction.getsubCategoryList(1));

      return () => {};
    }
    // getuserListSearch
    // &user_id=${data?.user_id}&search=${data?.user_id}
  };

  const hendlePahegi = (e) => {
    setPage(e);
    if (search) {
      dispatch(allapiAction.allcategorySearch({ page: e, search: search }));
      return () => {};
    } else {
      dispatch(allapiAction.getsubCategoryList(e));

      return () => {};
    }
  };

  const fshop = details?.Shops ? details?.Shops : [];
  const fplot = details?.Plots ? details?.Plots : [];

  console.log(fplot);

  const totalPlatArea = fplot.reduce((acc, item) => {
    return acc + item?.area;
  }, 0);
  console.log(totalPlatArea);

  const finalshop = fshop.sort((a, b) => {
    const getTypeAndNumber = (str) => {
      if (/^[0-9]+$/.test(str)) {
        return { type: "number", num: parseInt(str) };
      } else if (/^A-/i.test(str)) {
        return { type: "A", num: parseInt(str.split("-")[1]) };
      } else if (/^B-/i.test(str)) {
        return { type: "B", num: parseInt(str.split("-")[1]) };
      }
      return { type: "other", num: 0 }; // For unexpected cases
    };

    const valA = getTypeAndNumber(a.number);
    const valB = getTypeAndNumber(b.number);

    // Sort by type first: number < A < B
    if (valA.type !== valB.type) {
      const typeOrder = { number: 1, A: 2, B: 3 };
      return typeOrder[valA.type] - typeOrder[valB.type];
    }

    // If types are the same, sort by numeric value
    return valA.num - valB.num; // Sort by numeric value
  });
  const finalplot = fplot.sort((a, b) => {
    // const extractNumber = (str) => {
    //   if (str.includes('-')) {
    //     return parseInt(str.split('-')[1]); // Extract numeric part after "-"
    //   }
    //   return parseInt(str); // Treat as a number if no "-"
    // };

    // const numA = extractNumber(a.number);
    // const numB = extractNumber(b.number);
    // Extract numeric part of B
    // return numA - numB; // Sort by numeric value
    const getTypeAndNumber = (str) => {
      if (/^[0-9]+$/.test(str)) {
        return { type: "number", num: parseInt(str) };
      } else if (/^A-/i.test(str)) {
        return { type: "A", num: parseInt(str.split("-")[1]) };
      } else if (/^B-/i.test(str)) {
        return { type: "B", num: parseInt(str.split("-")[1]) };
      }
      return { type: "other", num: 0 }; // For unexpected cases
    };

    const valA = getTypeAndNumber(a.number);
    const valB = getTypeAndNumber(b.number);

    // Sort by type first: number < A < B
    if (valA.type !== valB.type) {
      const typeOrder = { number: 1, A: 2, B: 3 };
      return typeOrder[valA.type] - typeOrder[valB.type];
    }

    // If types are the same, sort by numeric value
    return valA.num - valB.num;
  });

  const soldShop = finalshop.filter((data) => data?.fullName);
  const soldPlot = finalplot.filter((data) => data?.fullName);
  const unsoldShop = finalshop.filter((data) => !data?.fullName);
  const unsoldPlot = finalplot.filter((data) => !data?.fullName);

  const totalsoldPlatArea = soldPlot.reduce((acc, item) => {
    return acc + item?.area;
  }, 0);
  console.log(totalsoldPlatArea);

  const [filter, setFilter] = useState("all");
  const finalplot1 =
    filter == "all" ? finalplot : filter == "unsold" ? unsoldPlot : soldPlot;
  const finalshop1 =
    filter == "all" ? finalshop : filter == "unsold" ? unsoldShop : soldShop;

  const loadOptionsPalyer = async (search, loadedOptions, page) => {
    const response = await fetch(
      URL.API_BASE_URL +
        `/publicApi/getSchemeListforDrop?search=${search}&page=${page?.page}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.name + " - " + data?.loaction;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page?.page + 1,
      },
    };
  };
  return (
    <div>
      {/* update */}
      <Modal
        title="Update Category"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <ImageUploading
            // multiple
            value={Imagesfe}
            onChange={onChangefe}
            maxNumber={maxNumber}
            dataURLKey="data_url"
            acceptType={["png", "jpeg", "jpg", "webp"]}
            // acceptType={['jpg']}
          >
            {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
            }) => (
              // write your building UI
              <div className="upload__image-wrapper">
                <button
                  style={isDragging ? { color: "red" } : {}}
                  onClick={onImageUpload}
                  {...dragProps}
                  className="btn btn-secondary"
                >
                  Choose image
                </button>
                &nbsp;
                {/* <button
                  className="btn btn-secondary"
                  onClick={onImageRemoveAll}
                >
                  Remove all images
                </button> */}
                {imageList.map((image, index) => (
                  <div key={index} className="image-item">
                    <img src={image.data_url} alt="" width="100" />
                    <div className="image-item__btn-wrapper">
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageUpdate(index)}
                      >
                        Update
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageRemove(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </ImageUploading>
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Select
            value={selectedOptionUpdate}
            onChange={setSelectedOptionUpdate}
            options={subList}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="name"
            name="name"
            value={cateDetail?.name}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="admin commisstion"
            name="admin_commisstion"
            value={cateDetail?.admin_commisstion}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta title"
            name="meta_title"
            value={cateDetail?.meta_title}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>

        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta description"
            name="meta_description"
            value={cateDetail?.meta_description}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
      </Modal>

      {/* create */}
      <Modal
        title="Create Plot/shop"
        open={addModalOpen}
        onOk={handleOkAdd}
        onCancel={handleCancelAdd}
      >
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            Please Choose
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <select
              className="form-control mt-8"
              name="type"
              value={cateDetailAdd?.type}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            >
              <option value="">Choose</option>
              <option value="Shop">Shop</option>
              <option value="Plot">Plot</option>
            </select>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            Plot/Shop No.
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="number"
              name="number"
              value={cateDetailAdd?.number}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            L X W Feet
          </Col>
          <Col lg={11} md={11} sm={11} xs={11}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="length"
              name="lengths"
              type="number"
              value={cateDetailAdd?.lengths}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>{" "}
          <Col lg={2} md={2} sm={2} xs={2}>
            <div className="pt-15 text-center">
              <span>X</span>
            </div>
          </Col>
          <Col lg={11} md={11} sm={11} xs={11}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="width"
              name="widths"
              type="number"
              value={cateDetailAdd?.widths}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            Area (Sq. Gaj)
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder=" area"
              name="area"
              type="number"
              value={cateDetailAdd?.area}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
        </Row>
      </Modal>

      <div className="flex">
        <div>
          <HeadingBack
            title={"Add Plot/Shop"}
            // subHeading={`Total ${users_list?.totalDocs || 0} Scheme Details`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          {/* <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
            // value={values?.TestCode}
          /> */}
          {/* <AsyncPaginate
            // key={managerKey}
            value={seleceteManger}
            loadOptions={loadOptionsgetManager}
            onChange={setseleceteManger}
            additional={{
              page: 1,
            }}
          /> */}
        </Col>

        <div className="flex1 flex justify-content-end align-items-center">
          {/* <Tooltip title="Add">
            <span className="jop_btn" onClick={() => showModalAdd()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip> */}
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <div className=" container mt-10 mb-20">
          <div className="dashboardBoxShad">
            <Row>
              <Col lg={24} md={24} sm={24} xs={24}>
                Select Scheme
              </Col>
              <Col lg={24} md={24} sm={24} xs={24}>
                <AsyncPaginate
                  value={userselete}
                  loadOptions={loadOptionsPalyer}
                  onChange={setuserselete}
                  additional={{
                    page: 1,
                  }}
                />
              </Col>
              <Col lg={24} md={24} sm={24} xs={24}>
                Please Choose
              </Col>
              <Col lg={24} md={24} sm={24} xs={24}>
                <select
                  className="form-control mt-8"
                  name="type"
                  value={cateDetailAdd?.type}
                  onChange={(e) => {
                    hendleTochangeCategoryAdd(e);
                  }}
                >
                  <option value="">Choose</option>
                  <option value="Shop">Shop</option>
                  <option value="Plot">Plot</option>
                </select>
              </Col>
              <Col lg={24} md={24} sm={24} xs={24}>
                Plot/Shop No.
              </Col>
              <Col lg={24} md={24} sm={24} xs={24}>
                <input
                  autoComplete="new-off"
                  className="form-control mt-8"
                  placeholder="number"
                  name="number"
                  value={cateDetailAdd?.number}
                  onChange={(e) => {
                    hendleTochangeCategoryAdd(e);
                  }}
                />
              </Col>
              <Col lg={24} md={24} sm={24} xs={24}>
                L X W Feet
              </Col>
              <Col lg={11} md={11} sm={11} xs={11}>
                <input
                  autoComplete="new-off"
                  className="form-control mt-8"
                  placeholder="length"
                  name="lengths"
                  type="number"
                  value={cateDetailAdd?.lengths}
                  onChange={(e) => {
                    hendleTochangeCategoryAdd(e);
                  }}
                />
              </Col>{" "}
              <Col lg={2} md={2} sm={2} xs={2}>
                <div className="pt-15 text-center">
                  <span>X</span>
                </div>
              </Col>
              <Col lg={11} md={11} sm={11} xs={11}>
                <input
                  autoComplete="new-off"
                  className="form-control mt-8"
                  placeholder="width"
                  name="widths"
                  type="number"
                  value={cateDetailAdd?.widths}
                  onChange={(e) => {
                    hendleTochangeCategoryAdd(e);
                  }}
                />
              </Col>
              <Col lg={24} md={24} sm={24} xs={24}>
                Area (Sq. Gaj)
              </Col>
              <Col lg={24} md={24} sm={24} xs={24}>
                <input
                  autoComplete="new-off"
                  className="form-control mt-8"
                  placeholder=" area"
                  name="area"
                  type="number"
                  value={cateDetailAdd?.area}
                  onChange={(e) => {
                    hendleTochangeCategoryAdd(e);
                  }}
                />
              </Col>
            </Row>

            <div className=" flex1 flex justify-content-center align-items-center mt-30">
              <Tooltip title="Add">
                <span className="jop_btn" onClick={() => handleOkAdd()}>
                  Submit
                  {/* <SvgIcon.Add width={40} height={40} className="cursor-pointer" /> */}
                </span>
              </Tooltip>
            </div>
            {/*  */}
          </div>
        </div>

        {/* <Table
          dataSource={listdata}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: users_list?.totalDocs ? users_list?.totalDocs : 0,
          }}
        /> */}
      </div>
    </div>
  );
}

export default AddProperty;
